var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX5 = function SvgX5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "m18.048 15.42-1.442-.349.553-5.024h5.476v1.497h-3.979l-.26 2.324q.213-.13.616-.26.409-.136.923-.136.71 0 1.271.232.56.226.95.656.397.431.595 1.053a4.4 4.4 0 0 1 .205 1.395q0 .683-.205 1.285-.198.595-.608 1.06a2.9 2.9 0 0 1-1.033.724q-.622.26-1.462.26a4 4 0 0 1-1.224-.185 3.4 3.4 0 0 1-1.046-.554 2.8 2.8 0 0 1-.745-.902 2.9 2.9 0 0 1-.301-1.223h1.784q.048.458.246.779.2.321.52.492.328.17.759.17.39 0 .67-.143.287-.15.471-.417a1.9 1.9 0 0 0 .274-.629q.088-.361.088-.793 0-.416-.102-.758a1.65 1.65 0 0 0-.315-.602 1.4 1.4 0 0 0-.533-.39 1.8 1.8 0 0 0-.738-.136q-.567 0-.875.17-.3.171-.533.404M8.023 18.62l-1.08-1.053 5.326-5.434 1.08 1.06zm4.26 0-5.326-5.428 1.073-1.06 5.326 5.435z"
  })));
};
export default SvgX5;